var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5968 17.5023C12.3217 17.5023 12.0966 17.7274 12.0996 18.0025C12.0996 18.2776 12.3247 18.5027 12.5998 18.5027C12.875 18.5027 13.1001 18.2776 13.1001 18.0025C13.1001 17.7274 12.875 17.5023 12.5968 17.5023",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5968 11.4998C12.3217 11.4998 12.0966 11.7248 12.0996 12C12.0996 12.2751 12.3247 12.5002 12.5998 12.5002C12.875 12.5002 13.1001 12.2751 13.1001 12C13.1001 11.7248 12.875 11.4998 12.5968 11.4998",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5968 5.49731C12.3217 5.49731 12.0966 5.72241 12.0996 5.99752C12.0996 6.27264 12.3247 6.49773 12.5998 6.49773C12.875 6.49773 13.1001 6.27264 13.1001 5.99752C13.1001 5.72241 12.875 5.49731 12.5968 5.49731",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.b1ae59be8cb8329e461a87b1ec125916.svg";
export { ForwardRef as ReactComponent };